import SessionEntity from './SessionEntity'
class BaseEntity {
  id= 0
}

export default BaseEntity
